import { OrderPhaseFooterCommandBase, OrderPhaseService } from '@app/shared/components';

export class PreviousSetupSubphaseCommandService implements OrderPhaseFooterCommandBase {
  public enabled = true;
  public buttonText: string;
  public required = false;
  public route: string;

  constructor(private setupFooterService: OrderPhaseService) {}

  public execute(): void {
    this.setupFooterService.goToPreviousSubPhase(this.route);
  }

  public setNavigationParams(route: string): void {
    this.route = route;
  }
}
